import { getUserMailboxInfo } from 'owa-client-ids';
import { MailboxInfo } from 'owa-client-ids';
import { getGroupMailboxInfo } from 'owa-group-common';
import { ComposeViewState } from 'owa-mail-compose-store';
import { PublicFolderComposeViewState, SharedFolderComposeViewState } from 'owa-mail-compose-store';
import isGroupComposeViewState from 'owa-mail-compose-store/lib/utils/isGroupComposeViewState';
import isPublicFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isPublicFolderComposeViewState';
import isSharedFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isSharedFolderComposeViewState';
import { getMailboxInfoFromFolderId } from 'owa-mail-mailboxinfo/lib/getMailboxInfo';
import { getPublicFolderMailboxInfo } from 'owa-publicfolder-utils';

export function getMailboxInfoFromViewState(viewState: ComposeViewState): MailboxInfo {
    if (isGroupComposeViewState(viewState)) {
        return getGroupMailboxInfo(viewState.groupId);
    } else if (isPublicFolderComposeViewState(viewState)) {
        const publicFolder = <PublicFolderComposeViewState>viewState;
        return getPublicFolderMailboxInfo(publicFolder.publicFolderId);
    } else if (isSharedFolderComposeViewState(viewState)) {
        const sharedFolder = <SharedFolderComposeViewState>viewState;
        return getMailboxInfoFromFolderId(sharedFolder.folderOwnerEmailAddress);
    }
    return getUserMailboxInfo();
}
